import { unitOfMeasureSelectStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { unitOfMeasureSelectStyles as UOMSelectandQTYOrdered } from "@tKgpco/Widgets/PDP/UOMSelectandQTYOrdered";
import merge from "lodash/merge";
import { css } from "styled-components";

export const unitOfMeasureSelectCss = () => {
    return css`
        margin-top: 0px;
        flex-direction: row;
        align-items: center;
        color: ${COLORS.lightBlack};
        label {
            text-align: center;
            padding: 9px;
            width: 50%;
            background-color: #e1e7ed;
            border-radius: 8px 0 0 8px;
            @media (max-width: 1199px) and (min-width: 992px) {
                font-size: 13px !important;
                padding: 11px 10px 10px;
            }
        }
        & > div {
            margin-top: 0 !important;
            select {
                background: #f1f6fb !important;
                border: 0 none !important;
                @media (max-width: 1199px) and (min-width: 992px) {
                    font-size: 13px !important;
                    padding: 0 5px !important;
                    span[class^="IconWrapper"] {
                        width: 30px !important;
                    }
                }

                @media (max-width: 991px) {
                    border-radius: 0 8px 8px 0 !important;
                }
            }
        }
    `;
};

Object.assign(UOMSelectandQTYOrdered, {
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                ${unitOfMeasureSelectCss()}
            `,
        },
    },
});

Object.assign(unitOfMeasureSelectStyles, {
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                ${unitOfMeasureSelectCss()}
            `,
        },
    },
});
